/**
 * Attendances API Module
 *
 * API calls for attendance (Anwesenheit) management
 */

import { apiClient } from './client'
import type { AttendanceDto, CreateAttendanceDto } from '@/types/api.types'

export const attendancesApi = {
  /**
   * Get all attendances for a session
   */
  async getBySession(sessionId: number): Promise<AttendanceDto[]> {
    const response = await apiClient.get<AttendanceDto[]>(`/Attendances/by-session/${sessionId}`)
    return response.data
  },

  /**
   * Create a new attendance record — das ist „anwesend".
   *
   * Serverseitig ein **Upsert**: ein zweiter POST für dieselbe (courseSessionId, personId)
   * liefert denselben Datensatz zurück statt ein Duplikat anzulegen (seit 2026-08-04, zusätzlich
   * per Unique-Index abgesichert).
   */
  async create(data: CreateAttendanceDto): Promise<AttendanceDto> {
    const response = await apiClient.post<AttendanceDto>('/Attendances', data)
    return response.data
  },

  /**
   * Delete an attendance record — das ist „abwesend" (Existenz = Anwesenheit).
   *
   * Ein `update` gibt es bewusst nicht: `PUT /api/Attendances/{id}` wurde am 2026-08-04
   * backendseitig entfernt (antwortet 404) und war vorher ein wirkungsloser No-Op.
   */
  async delete(id: number): Promise<void> {
    await apiClient.delete(`/Attendances/${id}`)
  },
}
